import React from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Input,
  FormGroup,
  Label,
  Button,
} from "reactstrap"

const OpportunityModal = ({
  isOpen,
  toggle,
  isEdit,
  formData,
  setFormData,
  onSave,
}) => {
  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {isEdit ? "Edit Opportunity" : "Add Opportunity"}
      </ModalHeader>

      <ModalBody>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Customer Name</Label>
              <Input
                className="rounded-4"
                name="customer"
                value={formData.customer}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label>Equipment Type</Label>
              <Input
                type="select"
                className="rounded-4"
                name="equipment"
                value={formData.equipment}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option>Excavator</option>
                <option>Backhoe Loader</option>
                <option>Wheel Loader</option>
                <option>Crane</option>
                <option>Dozer</option>
              </Input>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label>Model</Label>
              <Input
                name="model"
                className="rounded-4"
                value={formData.model}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label>Deal Value (₹)</Label>
              <Input
                type="number"
                className="rounded-4"
                name="value"
                value={formData.value}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label>Stage</Label>
              <Input
                type="select"
                className="rounded-4"
                name="stage"
                value={formData.stage}
                onChange={handleChange}
              >
                <option>Qualification</option>
                <option>Proposal</option>
                <option>Negotiation</option>
                <option>Won</option>
                <option>Lost</option>
              </Input>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label>Probability (%)</Label>
              <Input
                type="number"
                className="rounded-4"
                name="probability"
                value={formData.probability}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label>Expected Close Date</Label>
              <Input
                type="date"
                className="rounded-4"
                name="closeDate"
                value={formData.closeDate}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={onSave}>
          {isEdit ? "Update" : "Save"}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default OpportunityModal
